module.exports = __webpack_public_path__ + "static/media/evan_k.3dac9078.jpeg";